import React from 'react';
import ExperimentNav from '../../components/ExperimentNav';
import { experiments } from '../../App';
import './ScrollCinema.css';

// A 4-act cinematic scroll piece driven ENTIRELY by CSS scroll-driven
// animations (animation-timeline: scroll()/view()). There is no JS in the
// experience — this component renders only static markup; every motion lives
// in ScrollCinema.css. (The shared ExperimentNav "back to lab" chrome is the
// only React on the page.)
//
// Structure: `.cinema` is a non-scrolling wrapper that `timeline-scope`s the
// `--page` name; `.scroller` is the real scroll container that DEFINES it.
// The pinned layers (lime / circle / converge) are siblings of `.scroller`, so
// they can only see `--page` because of the timeline-scope hoist.
const ScrollCinema: React.FC = () => {
  const exp = experiments.find(e => e.id === 'scroll-cinema');
  const word = 'SIGNAL'.split('');

  return (
    <div className="cinema">
      <ExperimentNav prompt={exp?.prompt} title={exp?.title} />

      {/* pinned background colour (shares --page via timeline-scope) */}
      <div className="bgLime" aria-hidden="true" />

      {/* the scroll container: defines --page, holds the acts */}
      <div className="scroller">
        <section className="act a1">
          <h1 className="title">
            {word.map((c, i) => (
              <span key={i} className={`ltr l${i + 1}`}>{c}</span>
            ))}
          </h1>
        </section>

        <section className="act a2">
          <p className="line">the image breaks<br />and colour floods in</p>
        </section>

        <section className="act a3">
          <h2 className="blend">OVERLAP</h2>
        </section>

        <section className="act a4">
          <p className="end">everything<br />settles to grey</p>
        </section>
      </div>

      {/* pinned overlays (also share --page via timeline-scope) */}
      <div className="circle" aria-hidden="true" />
      <div className="converge" aria-hidden="true" />
    </div>
  );
};

export default ScrollCinema;
